import { render, staticRenderFns } from "./studentClassList.vue?vue&type=template&id=b315d3da&scoped=true&"
import script from "./studentClassList.vue?vue&type=script&lang=js&"
export * from "./studentClassList.vue?vue&type=script&lang=js&"
import style0 from "./studentClassList.vue?vue&type=style&index=0&id=b315d3da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b315d3da",
  null
  
)

export default component.exports